import React from "react";
import { toast } from "react-toastify";
import { LanguageConstants } from "../../../constants/LanguageConstants";
import { isQuoteLineUnavailable } from "./helpers";
import { QuotationItemCard } from "./QuotationItemCard";

export type QuotationLineRow = {
  kind: "api" | "pending";
  res: any;
  displayNo: number;
};

export type RenderQuotationItemCardsParams = {
  rows: QuotationLineRow[];
  getBrandForRow: (res: any, isPending: boolean) => string;
  buildProductTitle: (res: any, brand: string) => string;
  canEditRow: boolean;
  anotherBlocks: boolean;
  tableQtyEditingQuoteId: number | string | null;
  isQuotedView: boolean;
  renderQtyControl: (
    res: any,
    kind: "api" | "pending",
    displayNo: number,
    editDis: boolean,
  ) => React.ReactNode;
  formatQuotedMoneyCell: (res: any, which: "unit" | "extended") => string;
  formatQuotedEtaCell: (res: any) => string;
  handleRowQtyEdit: (
    res: any,
    kind: "api" | "pending",
    displayNo: number,
    editDis: boolean,
  ) => void;
  onDeleteLine: (res: any, displayNo: number) => void;
};

export function renderQuotationItemCards({
  rows,
  getBrandForRow,
  buildProductTitle,
  canEditRow,
  anotherBlocks,
  tableQtyEditingQuoteId,
  isQuotedView,
  renderQtyControl,
  formatQuotedMoneyCell,
  formatQuotedEtaCell,
  handleRowQtyEdit,
  onDeleteLine,
}: RenderQuotationItemCardsParams): React.ReactNode {
  return rows.map((row) => {
    const { res, displayNo, kind } = row;
    const brand = getBrandForRow(res, kind === "pending") || "N/A";
    const editDis = anotherBlocks;
    const qtyUnavailable = isQuoteLineUnavailable(res);
    const qtyEditOpenForThisRow =
      tableQtyEditingQuoteId != null &&
      (kind === "api"
        ? String(tableQtyEditingQuoteId) === String(res?.id)
        : String(tableQtyEditingQuoteId) === `pending-${res?.__pendingAnotherProductIndex ?? ""}`);
    const title = buildProductTitle(res, brand);

    return (
      <QuotationItemCard
        key={kind === "api" ? `api-${res?.id}` : `pen-${displayNo}-${res?.part_number}`}
        itemIndex={displayNo}
        res={res}
        canEdit={Boolean(canEditRow)}
        editDisabled={editDis || qtyUnavailable || qtyEditOpenForThisRow}
        onEdit={() => handleRowQtyEdit(res, kind, displayNo, editDis)}
        onDelete={() => {
          if (editDis) toast.error(LanguageConstants?.MESSAGE_FOR_PRODUCT);
          else onDeleteLine(res, displayNo);
        }}
        productTitle={title}
        qtyDisplay={renderQtyControl(res, kind, displayNo, editDis)}
        showQuotedPricing={isQuotedView}
        unitPriceDisplay={formatQuotedMoneyCell(res, "unit")}
        extendedPriceDisplay={formatQuotedMoneyCell(res, "extended")}
        etaDisplay={formatQuotedEtaCell(res)}
      />
    );
  });
}
